/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import ContentSuiteWhiteIcon from '../styles/assets/ContentSuiteWhiteIcon.svg';
import ContentSuiteWhite from '../styles/assets/ContentSuiteWhite.svg';
import '../styles/app.css';
import { useSession } from '../store/sessionContext';
import { Layout, Menu } from 'antd';
import PopUpHover from '../components/PopUpMenu/PopUpHover';
import { useSideBarStatus } from '../store/sidebarContext';
import UserOutlined from '../styles/assets/userManagement.svg';
import FileDoneOutlined from '../styles/assets/PropertyContent.svg';
import ReportsIcon from '../styles/assets/Report.svg';
import { GetUserName } from '../helpers/misc/CapitalizeFirstLetter';
import { FeatureFlag } from '../factories/index';
import { TITLE } from '../constants';
import { pingLogOut } from '../helpers/ping';
import { isAdminUser } from '@helpers/users/index';

interface SubItems {
  title: string;
  id: string;
  icon: ReactElement | null;
}

interface Items {
  title: string;
  icon: React.ReactElement;
  subMenu: SubItems[];
  includes?: (param: string | number) => void | undefined;
}

const propertyContenMenu = {
  title: 'Property Content',
  icon: <img src={FileDoneOutlined} alt='side menu icon' />,
  subMenu: [
    {
      title: 'Property Search',
      id: 'propertySearch',
      icon: null
    }
  ]
};

const userManagementMenu = {
  title: 'User Management',
  icon: <img src={UserOutlined} alt='side menu icon' />,
  subMenu: [
    /*{
            title:'Roles',
            id:'roles',
            icon:null
        },*/
    {
      title: 'Users',
      id: 'users',
      icon: null
    }
  ]
};

const reportsMenu = {
  title: 'Reports',
  icon: <img src={ReportsIcon} alt='side menu icon' />,
  subMenu: [
    {
      title: 'Content Audit Report',
      id: 'reports',
      icon: null
    }
  ]
};

let menuItems: Items[] = [];

interface propsTypes {
  subMenuStatus: boolean;
  hasFocus: boolean;
  setSubMenuStatus: (val: boolean) => void;
  setHasFocus: (val: boolean) => void;
  short?: boolean;
  showMenu?: boolean;
}

const Sidebar = ({
  subMenuStatus,
  setSubMenuStatus,
  hasFocus,
  setHasFocus,
  short = false,
  showMenu = true
}: propsTypes) => {
  const { session } = useSession();
  // const { cleanUp } = useIdleTimer()
  const [collapsed, setCollapsed] = React.useState<boolean>(false);
  const { sidebarStatus } = useSideBarStatus();
  const [_, setReady] = useState(false);
  const [user, setUser] = useState<string>('');

  const { Sider } = Layout;
  const { SubMenu } = Menu;

  /**
   * Feature Flag for side bar
   **/
  const FeatureFlags: any = useCallback(async () => {
    // IAM verifying if is an admin user
    const isAdmin = await isAdminUser();
    const username = session.userName as string;
    const isInternalUser: boolean = username.includes('derbysoft');

    const propertyContentFlag = new FeatureFlag(process.env.REACT_APP_PROPERTY_CONTENT);
    propertyContentFlag.validationByFilter({
      validationParam: TITLE,
      source: menuItems,
      resources: propertyContenMenu
    });
    const userManagementFlag = new FeatureFlag(process.env.REACT_APP_USER_MANAGMENT);
    isAdmin &&
      userManagementFlag.validationByFilter({
        validationParam: TITLE,
        source: menuItems,
        resources: userManagementMenu
      });
    isInternalUser &&
      propertyContentFlag.validationByFilter({
        validationParam: TITLE,
        source: menuItems,
        resources: reportsMenu
      });
    // onready flag to fired up the component re-render
    setReady(true);
  }, []);

  useEffect(() => {
    if (sidebarStatus) {
      setCollapsed(true);
    }
    if (short) setCollapsed(true);
    return FeatureFlags();
  }, [sidebarStatus, FeatureFlags, short]);

  const logOut = async () => {
    return await pingLogOut({ token: session.token });
  };

  const onCollapse = (collapsed: boolean) => {
    setCollapsed(collapsed);
  };

  const handleMenus = () => {
    setSubMenuStatus(!subMenuStatus);
    setHasFocus(!hasFocus);
  };

  const selectOpt = (opt: string) => {
    switch (opt) {
      case 'users':
        window.location.href = '/userManagement';
        break;
      case 'propertySearch':
        window.location.href = '/listing';
        break;
      /* case 'roles': window.location.href = '/rolelist'*/
      case 'reports':
        window.location.href = '/reports';
        break;
    }
  };

  return (
    <>
      <Sider
        collapsedWidth='48'
        width='248'
        className='Sider'
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}>
        <div className='logo-wrapper'>
          <img className='isotype' src={ContentSuiteWhiteIcon} alt='demo' />
          <img className='logotype' src={ContentSuiteWhite} alt='demo' />
        </div>
        <Menu className='Sider-menu' triggerSubMenuAction={collapsed ? 'hover' : 'click'} theme='dark' mode='inline'>
          {menuItems &&
            !short &&
            menuItems.map((item, i) => {
              return (
                <SubMenu
                  className='Sider-menu-subMenu'
                  popupOffset={[0, 0]}
                  key={'sub' + i}
                  icon={item.icon}
                  title={item.title}>
                  {collapsed && (
                    <Menu.Item
                      style={{ width: collapsed ? '220px' : 'auto' }}
                      className='rootMenuItem'
                      key={'index' + i}>
                      {item.title}
                    </Menu.Item>
                  )}
                  {item.subMenu &&
                    item?.subMenu.map((subItem, subIndex) => {
                      return (
                        <Menu.Item
                          onClick={() => selectOpt(subItem.id)}
                          className='Sider-menu-item'
                          key={'subMenuIndex' + subIndex}>
                          {subItem.title}
                        </Menu.Item>
                      );
                    })}
                </SubMenu>
              );
            })}
          {collapsed && !short && <Menu.Divider className='menuDivider' />}
        </Menu>
        {showMenu && (
          <div className='userInfo-wrapper'>
            <button
              onClick={handleMenus}
              className={'userInfo ' + (collapsed ? 'collapsed ' : '') + (!hasFocus ? 'noFocus' : '')}>
              {session && session.userName && (
                <div className={'userInfo-name ' + (collapsed ? 'collapsed ' : '') + (!hasFocus ? 'noFocus' : '')}>
                  {session.userName.slice(0, 1).toUpperCase()}
                </div>
              )}

              <div className={'userInfo-email ' + (collapsed ? 'collapsed' : '')}>
                <span>{GetUserName(session)}</span>
                <span>{session.email}</span>
              </div>
            </button>
            <PopUpHover
              name={GetUserName(session)}
              email={session.email}
              logOut={logOut}
              collapsed={collapsed}
              className={
                'PopupMenuHover ' +
                (collapsed ? 'collapsed ' : 'notCollapsed ') +
                (subMenuStatus && collapsed ? 'open' : subMenuStatus && !collapsed ? 'openExtend' : 'close')
              }
            />
          </div>
        )}
      </Sider>
    </>
  );
};

export default Sidebar;
